import NoDataLayout from './NoDataLayout';

export default NoDataLayout;
